import { configureStore, combineReducers } from "@reduxjs/toolkit";
import GraphReducer from './reducers/GraphReducer'
import DecayReducer from "./reducers/DecayReducer";
import MainGraphReducer from "./reducers/MainGraphReducer";
import FinalStateReducer from "./reducers/FinalStateReducer";
import IsobarReducer from "./reducers/IsobarReducer";
import DecayLockReducer from "./reducers/DecayLockReducer";
import PDGParticleReducer from "./reducers/PDGParticleReducer";
import GraphCheckReducer from "./reducers/GraphCheckReducer";
import treeMaskReducer from "./reducers/TreeMaskReducer";
import MessageReducer from "./reducers/MessageReducer";
import IdenticalParticleReducer from "./reducers/IdenticalParticleReducer";
import FilterReducer from "./reducers/FilterReducer";
import IsobarViewFilterReducer from "./reducers/IsobarViewFilterReducer";
import ClientFilterReducer from "./reducers/ClientFilterReducer";
import LineshapeSchemaReducer from "./reducers/LineshapeSchemaReducer";
import BackendReducer from "./reducers/BackendReducer";
import ObjectCacheReducer from "./reducers/ObjectCacheReducer";

const reducers = combineReducers({
    decay: DecayReducer,
    graph: GraphReducer,
    mainGraph: MainGraphReducer,
    finalState: FinalStateReducer,
    intermediateState: IsobarReducer,
    decayLock: DecayLockReducer,
    pdgParticles: PDGParticleReducer,
    checkedGraphs: GraphCheckReducer,
    treeMask: treeMaskReducer,
    messages: MessageReducer,
    identicalParticles: IdenticalParticleReducer,
    topologyFilter: FilterReducer,
    isobarViewFilter: IsobarViewFilterReducer,
    clientFilters: ClientFilterReducer,
    lineshapeSchemas: LineshapeSchemaReducer,
    backend: BackendReducer,
    objectCache: ObjectCacheReducer
  });



const mainReducer = (state, action) => {
    if (action.type === "HYDRATE") {
        const nextState = {
            ...state,
            ...action.payload,
        };
        return nextState;
    }
    return reducers(state, action);
};

const createStore = () => {
    return configureStore({
        reducer: mainReducer,
    });
};

export default createStore;
